import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { map } from "ramda";

import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import selectedCastNumber from "utils/selectedCastNumber";

const MultiCast = ({ templateGroup, label, sizing, size, fullWidth }) => {
  const castNumOptions = TemplateGroupPresenter.castNumOptions(templateGroup);
  const [castNum, setCastNum] = useState(TemplateGroupPresenter.castsCount(templateGroup));
  const selectOptions = map((value) => {
    const text = value === 1 ? "1 Person" : `${value} People`;
    return (
      <MenuItem value={value} key={value}>
        {text}
      </MenuItem>
    );
  }, castNumOptions);

  const handleChange = (event) => {
    const { value } = event.target;
    setCastNum(value);
    selectedCastNumber.set(value);
  };

  useEffect(() => {
    selectedCastNumber.set(castNum);
  }, []);

  return (
    <FormControl sx={sizing} size={size} fullWidth={fullWidth}>
      <InputLabel id="select-cast-label">{label}</InputLabel>
      <Select labelId="select-cast-label" id="select-cast" value={castNum} onChange={handleChange} label={label}>
        {selectOptions}
      </Select>
    </FormControl>
  );
};

MultiCast.propTypes = {
  templateGroup: TemplateGroupPresenter.shape(),
  label: PropTypes.string,
  sizing: PropTypes.shape(),
  size: PropTypes.string,
  fullWidth: PropTypes.bool,
};

export default MultiCast;
